import { justNumbers } from "./justnumbers";

export function formatPhone(ph:string){
  const phone=justNumbers(ph);
  if(!phone)return '';
  if(phone.length==1){
    return `(${phone}`;
  }
  if(phone.length==2){
     return `(${phone}`;
  }
  if(phone.length<=6){
     return `(${phone.substring(0,2)}) ${phone.substring(2)}`;
  }
  if(phone.length<=10){
     return `(${phone.substring(0,2)}) ${phone.substring(2,6)}-${phone.substring(6)}`;
  }
  return `(${phone.substring(0,2)}) ${phone.substring(2,3)} ${phone.substring(3,7)}-${phone.substring(7)}`;
}

export function normalizePhone(ph?:string){
   if(!ph)
      return '';
   const usePhone=ph.slice(2);
   if(usePhone.length==10){
      return `${usePhone.slice(0,2)}9${usePhone.slice(2)}`;
   }
   return usePhone;
}

/**
 * Gera as duas formas canônicas de um celular brasileiro: com e sem o 9º dígito
 * (`55 + DDD + 9 + número` de 13 dígitos e `55 + DDD + número` de 12). Espelha o
 * `buildPhoneVariants` do backend. Retorna null se não parecer um número BR.
 */
export function buildPhoneVariants(phone:string):[string,string]|null{
  const base=justNumbers(phone||'');
  let phone13:string|null=null;
  let phone12:string|null=null;
  switch(base.length){
    case 13: // 55 + DDD + 9 + número
      phone13=base;
      phone12=base.slice(0,4)+base.slice(5);
      break;
    case 12: // 55 + DDD + número
      phone12=base;
      phone13=base.slice(0,4)+'9'+base.slice(4);
      break;
    case 11: // DDD + 9 + número
      phone13='55'+base;
      phone12='55'+base.slice(0,2)+base.slice(3);
      break;
    case 10: // DDD + número
      phone12='55'+base;
      phone13='55'+base.slice(0,2)+'9'+base.slice(2);
      break;
  }
  return phone13&&phone12?[phone13,phone12]:null;
}

/**
 * Compara dois identificadores de cliente como "iguais", tolerando o 9º dígito
 * (ex.: `5549998144777` == `554998144777`). Para wa_id que não é telefone, cai
 * no comparativo direto de dígitos.
 */
export function phoneEquals(a?:string|null,b?:string|null):boolean{
  if(!a||!b)return false;
  const na=justNumbers(a);
  const nb=justNumbers(b);
  if(!na||!nb)return false;
  if(na===nb)return true;
  const va=buildPhoneVariants(na);
  const vb=buildPhoneVariants(nb);
  if(!va||!vb)return false;
  return va[0]===vb[0];
}